<template>
  <q-card flat style="width: 500px; max-width: 80vw;">
    <q-card-section>
      <div class="text-bold">{{ RequestInfo.Cs_Name }}</div>
      <q-badge class="bg-info-14">{{ RequestInfo.RequestType }}</q-badge>
    </q-card-section>
    <q-form autofocus
            ref="mainForm"
            greedy
            @submit.prevent="onDialogSubmit"
            @reset="onDialogReset"
            class="q-gutter-md q-gutter-sm">
      <q-card-section>
        <q-field
            v-model="RequestInfo.CreditValue"
            mask="currency"
            label="اعتبار"
            autofocus
            dir="ltr"
            label-color="indigo"
            lazy-rules
            :rules="[
                       val => parseInt(val.toString().replaceAll(',','')) > 0  || 'اعتبار عددی بزرگتر صفر می باشد، لطفا اصلاح نمایید'
                    ]">
          <template v-slot:control="{ id, floatingLabel, value, emitValue }">
            <input :id="id" class="q-field__native text-right" :value="value"
                   @change="e => emitValue(e.target.value)" v-money="moneyFormatForDirective"
                   v-show="floatingLabel">
          </template>
        </q-field>
        <q-toggle color="red" v-model="rejected" class="q-mt-md text-red-14">رد درخواست</q-toggle>
        <q-input
            :dense="$q.screen.lt.md"
            v-if="rejected"
            v-model="rejectedComment"
            filled
            type="textarea"
            label="علت رد درخواست"
            autofocus
            lazy-rules
            :rules="[
                          val => val !== null && val !== '' && rejected || 'علت در درخواست را وارد نمایید'
                    ]"
        />
        <q-separator/>
        <div class="items-center justify-center row q-mt-xs q-mt-sm q-mt-ma">
        </div>
      </q-card-section>

      <q-card-actions align="right">
        <q-btn label="تایید" type="submit" color="primary" icon="check"/>
        <q-btn flat label="انصراف" color="red" icon="cancel" v-close-popup/>
      </q-card-actions>
    </q-form>
  </q-card>
</template>

<script>
import {mapActions} from "vuex";

export default {
  name: "CreditRequestAction",
  props: ['RequestInfo'],
  data() {
    return {
      rejected: false,
      rejectedComment: '',
      allowCloseDialog: false,
      moneyFormatForDirective: {
        decimal: '.',
        thousands: ',',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: false
      },
    }
  },
  methods: {
    ...mapActions({
      ChangeCredit: 'Customers/change_credit',
    }),
    onDialogSubmit() {
      this.ChangeCredit({
        ecap_customer_id: this.RequestInfo.Cs_ID,
        creditValue: this.RequestInfo.CreditValue.toString().replaceAll(',', ''),
        field: this.RequestInfo.FieldName,
        Id: this.RequestInfo.ID,
        Rejected: this.rejected === true ? 1 : 0,
        reason: this.rejectedComment
      }).then((res) => {
        if (res.data.length > 0) {
          if (this.rejected) {
            this.$q.notify({
              message: `اعتبار درخواستی رد گردید`,
              color: 'negative',
              position: 'top',
              type: 'negative'
            });
          } else {
            this.$q.notify({
              message: `مبلغ اعتبار تغییر داده شد`,
              color: 'positive',
              position: 'top',
              type: 'positive'
            });
          }
          this.$emit('close-dialog');
        }
      }).catch(() => {
        this.$q.notify({
          message: 'اعتبار تغییر داده نشد',
          color: 'red',
          position: 'top',
          type: 'negative'
        });
      });
    },
    onDialogReset() {

    }
  }
}
</script>

<style scoped>

</style>
